export const initNewsletter = () => {
  const form = document.querySelector('.site-footer__newsletter-form');
  if (!form || typeof window.omoiyariNewsletter === 'undefined') return;

  const message = form.querySelector('.site-footer__newsletter-message');
  const submit = form.querySelector('.site-footer__newsletter-submit');
  const emailInput = form.querySelector('input[type="email"]');
  const consentInput = form.querySelector('input[type="checkbox"]');

  const setMessage = (text, type) => {
    if (!message) return;
    message.textContent = text || '';
    message.classList.remove('is-success', 'is-error');
    if (type) message.classList.add(type === 'success' ? 'is-success' : 'is-error');
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    setMessage('', null);

    const data = new FormData();
    data.append('action', 'omoiyari_newsletter');
    data.append('nonce', window.omoiyariNewsletter.nonce);
    data.append('email', emailInput ? emailInput.value.trim() : '');
    data.append('consent', consentInput && consentInput.checked ? '1' : '');

    if (submit) submit.disabled = true;

    try {
      const response = await fetch(window.omoiyariNewsletter.ajaxUrl, {
        method: 'POST',
        body: data,
      });
      const result = await response.json();

      if (result.success) {
        setMessage(result.data && result.data.message, 'success');
        form.reset();
      } else {
        setMessage(result.data && result.data.message ? result.data.message : 'Wystąpił błąd.', 'error');
      }
    } catch (error) {
      setMessage('Błąd połączenia. Spróbuj ponownie.', 'error');
    } finally {
      if (submit) submit.disabled = false;
    }
  });
};
